<template>
  <login v-if="!isRegistered"></login>
  <confirm-user v-else-if="!isConfirmed"></confirm-user>
  <user-details v-else-if ="!showDetails"></user-details>
   <has-error v-else-if="!hasError"> </has-error>
   <has-played v-else-if="!hasPlayed"></has-played>
  <instructions v-else-if="!readInstructions"></instructions>
  <completed v-else-if="isCompleted"></completed>
  <quiz v-else></quiz>
</template>

<script>
import { mapGetters } from 'vuex';
import Login from './login.vue';
import ConfirmUser from './confirm.vue';
import UserDetails from './details.vue';
import Instructions from './instructions.vue';
import Completed from './completed.vue';
import Quiz from './quiz.vue';
import HasPlayed from './hasPlayed';
import HasError from './error';

export default {
  name: 'Desktop',
  components: {
    Login,
    ConfirmUser,
    Instructions,
    Completed,
    Quiz,
    HasPlayed,
    HasError,
    UserDetails
  },
  computed: {
    ...mapGetters(['isRegistered', 'readInstructions', 'isCompleted', 'isConfirmed', 'hasPlayed', 'hasError', 'showDetails']),
  },
};
</script>
